export default __webpack_public_path__ + "static/media/glenn.b32970bd.jpg";